import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl: string;
  public accessToken: string = '';

  constructor(private http: HttpClient) {
    this.baseUrl = window.location.origin;
  }
}
